export const iconFontAwesomeSpinnersCertificate = (
	<i className="fa-solid fa-certificate"></i>
);
